import { Close as CloseIcon } from '@material-ui/icons';
import { t } from '@lingui/macro';

import { Action } from './Actions';
import { useLayout } from '../panel-container/Layout';

export default function RemoveAction({ id }) {
    const { onRemovePanel } = useLayout();
    return <Action icon={<CloseIcon />} tooltip={t`Remove this panel`} onClick={() => onRemovePanel(id)} />;
}
